import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

import { EditTransitionComponent } from '../edit-transition/edit-transition.component';
import { FullscreenDirective } from '../directive/fullscreen.directive';
import { StateMachineComponent } from '../workflow/state-machine.component';
import { WorkflowLayoutCalculator } from './layoutCalculator';

@Component({
  selector: 'irembogov-state-machine-preview',
  templateUrl: './state-machine-preview.component.html',
  styleUrls: ['./state-machine-preview.component.scss'],
})
export class WorkflowEditorComponent implements OnChanges {
  @Input() workflowCode: any;
  @Output() workflowUpdated = new EventEmitter<any>();
  recalculateAction$ = new Subject<void>();

  @ViewChild('stateMachine') stateMachine!: StateMachineComponent;
  @ViewChild(FullscreenDirective, { static: true })
  fullscreen!: FullscreenDirective;

  private layoutCalculator = new WorkflowLayoutCalculator();

  zoomAction$ = new Subject<'in' | 'out' | 'reset'>();

  savingInProgress = false;
  isCodeView = false;
  updateLine = 0;
  isFullscreen = false;
  fullscreenElement?: HTMLElement;
  zoomAction: { type: 'in' | 'out' | 'reset'; timestamp: number } | null = null;

  constructor(private modalService: NgbModal) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['workflowCode'] && !changes['workflowCode'].isFirstChange()) {
      this.workflowCode = changes['workflowCode'].currentValue;
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll() {
    this.updateLine = this.updateLine + 1;
  }

  getUpdatedWorkflow(event: any) {
    this.workflowCode = event;
    this.workflowUpdated.emit(this.workflowCode);
  }

  calculateLayout() {
    this.recalculateAction$.next();
  }

  toggleCodeView() {
    this.isCodeView = !this.isCodeView;
  }

  addNewTransition() {
    const modalRef = this.modalService.open(EditTransitionComponent, {
      centered: true,
      windowClass: 'state-workflow-editor-modal',
    });
    modalRef.componentInstance.workflowCode = this.workflowCode;

    modalRef.result
      .then((result: any) => {
        if (result) {
          this.workflowCode = [...this.workflowCode, result];
          this.workflowUpdated.emit(this.workflowCode);
        }
      })
      .finally(() => {
        modalRef.close();
      });
  }

  toggleFullscreen() {
    this.fullscreen.toggle();
  }

  onFullscreenChange($event: any) {
    this.isFullscreen = $event.isFullscreen;
  }

  handleZoomIn() {
    this.zoomAction$.next('in');
  }

  handleZoomOut() {
    this.zoomAction$.next('out');
  }

  handleResetZoom() {
    this.zoomAction$.next('reset');
  }
}
